var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectTeamInstruction',{attrs:{"name":"attacking-width","value":_vm.attackingWidth,"mutation":"updateAttackingWidth","options":_vm.options.attackingWidth}},[_vm._v(" "+_vm._s(_vm.$t('tactics.instructions.inPossession.attackingWidth.attackingWidth'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }